// extracted by mini-css-extract-plugin
export default {"card_item":"ShopList_card_item__Gx+BD"};